import { useState } from "react"
import { BsPlusCircle } from "react-icons/bs"
import isEqual from "lodash/isEqual"

import classNames from "@src/utilities/class-names"

export type CategoryFilterLink = {
  name: string
  path: string
}

export interface CategoryFilterProps {
  links: CategoryFilterLink[]
  selectedLink?: CategoryFilterLink
  title?: string
  viewAllPath: string
}

const liClassNames = classNames("bg-white md:inline-block md:ml-4")
const linkClassNames = classNames(
  "border-2 border-t-0 border-black block color-black px-4",
  "md:border-gray md:border md:border-t md:pt-2 md:pb-1 md:relative",
  "after:bg-black after:bottom-0 after:content-[''] after:block after:h-0.5 after:left-0 after:absolute after:scale-x-0 after:w-full after:origin-center after:transition-transform",
  "hover:after:scale-x-100"
)
const activeLinkClassNames = classNames("border border-black after:scale-x-100")

export default function CategoryFilter({
  links,
  selectedLink,
  title,
  viewAllPath,
}: CategoryFilterProps) {
  const [open, setOpen] = useState<boolean>(false)

  return (
    <div className="container-laptop" data-component="category-filter">
      <div className="text-center max-w-sm mx-auto mb-16 md:max-w-none">
        {title && <p className="italic">{title}</p>}
        <nav
          data-category-filter-open={open}
          className="font-sans font-bold text-sm relative uppercase"
        >
          <button
            className="bg-white border border-gray-300 border-b-black border-b-[3px] block px-4 pt-3 pb-2 relative uppercase w-full transition-all md:hidden"
            onClick={() => setOpen((prevState) => !prevState)}
          >
            {selectedLink ? selectedLink.name : "View All"}
            <span className="block pt-2 absolute right-2 top-1 transition-transform md:hidden">
              <BsPlusCircle />
            </span>
          </button>
          <ul className="opacity-0 pointer-events-none absolute top-full z-[1] w-full md:opacity-100 md:relative md:z-[0] md:top-auto md:w-auto md:pointer-events-auto md:-ml-4">
            <li
              className={classNames(liClassNames, "hidden md:inline-block")}
              data-active={!selectedLink}
            >
              <a
                href={viewAllPath}
                className={classNames(
                  linkClassNames,
                  !selectedLink ? activeLinkClassNames : ""
                )}
              >
                View All
              </a>
            </li>
            {links.map((link, idx) => (
              <li
                key={`filter-${idx}`}
                className={classNames(
                  liClassNames,
                  isEqual(selectedLink, link) ? "hidden md:inline-block" : ""
                )}
                data-active={isEqual(selectedLink, link)}
                data-selected={isEqual(selectedLink, link)}
              >
                <a
                  href={link.path}
                  className={classNames(
                    linkClassNames,
                    isEqual(selectedLink, link) ? activeLinkClassNames : ""
                  )}
                >
                  {link.name}
                </a>
              </li>
            ))}
            {selectedLink && (
              <li className={classNames(liClassNames, "md:hidden")}>
                <a className={classNames(linkClassNames)} href={viewAllPath}>
                  View All
                </a>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </div>
  )
}
